import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Context } from '../Context/Context';
import profileImgPng from "../images/profile.png"
import profileImgWebp from "../images/profile.webp"

// import jantriWebp from "https://app.matkajantri.com/JantriImage/JantriLogo.webp"
// import jantriPng from "https://app.matkajantri.com/JantriImage/JantriLogo.png"
import { Helmet } from 'react-helmet';

export default function Home() {

  const navigate = useNavigate();
  // const { pathname } = useLocation();

  const { wallet, setSideBarOpen, socket, setLoad } = useContext(Context)
  const userInfo = JSON.parse(localStorage.getItem('userinfo'));

  const [isOpen, setIsOpen] = useState(false)
  // const [isDepositOpen, setIsDepositOpen] = useState(false)
  const whatsappUrl = `https://wa.me/${process.env.REACT_APP_MOBILE_NO}`;
  // const [isWithdrawOpen, setIsWithdrawOpen] = useState(false)
  console.log("whatsappUrl -> ", whatsappUrl)
  const handleLogout = () => {
    socket?.disconnect();
    setLoad(false);
    localStorage.removeItem('userinfo');
    navigate('/');
  }

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (isOpen && e.target.closest('.wrapper') === null) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [isOpen]);

  useEffect(() => {
    setSideBarOpen(isOpen);
  }, [isOpen, setSideBarOpen]);

  return (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Home | Matka Jantri - Play & Manage Matka Bets</title>

        {/* Meta Description for SEO */}
        <meta
          name="description"
          content="This is the main home screen where all client and bazar lists are shown. Users can place Matka Satta bets, view numbers, and see the total amount of bets per number. The best Jantri app with easy-to-use features for Matka players."
        />

        {/* Robots Directive */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://pushpabetfair.com/" />

        {/* Favicon and Icons */}
        <link rel="icon" href="/favicon.ico" type="image/x-icon" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

        {/* Preload Key Images for Performance */}
        <link
          rel="preload"
          as="image"
          href="https://app.matkajantri.com/JantriImage/JantriLogo.webp"
          type="image/webp"
          fetchpriority="high"
        />
        <link
          rel="preload"
          as="image"
          href="https://app.matkajantri.com/JantriImage/JantriLogo.png"
          type="image/png"
          fetchpriority="high"
        />

        {/* Open Graph for Social Media */}
        <meta property="og:title" content="Home | Matka Jantri - Manage & Place Your Matka Bets" />
        <meta
          property="og:description"
          content="Place and manage Matka Satta bets on the homepage. View client and bazar lists, bet numbers, and see bet totals. Fast, easy and trusted Matka Jantri platform."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://pushpabetfair.com" />
        <meta property="og:image" content="https://pushpabetfair.com/Logo.png" />
        <meta name="google-site-verification" content="d6d81656210c6db7" />
      </Helmet>

      <div className='content'>
        {/* <div className="Companylogo">
          <img src="https://1.bp.blogspot.com/-vhmWFWO2r8U/YLjr2A57toI/AAAAAAAACO4/0GBonlEZPmAiQW4uvkCTm5LvlJVd_-l_wCNcBGAsYHQ/s16000/team-1-2.jpg" alt="profile_picture" />
          <h1>Yells Club</h1>
        </div> */}
        <div className={`wrapper ${isOpen ? '' : 'active'}`}>
          <div className="section">
            <div className="top_navbar">
              {/* Use a button for better semantics and accessibility */}
              <div className="hamburger">
                <button
                  onClick={() => setIsOpen(!isOpen)}
                  aria-label="Toggle menu" // Accessible name for screen readers
                  style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'white', fontSize: 'inherit' }} // Basic button reset styles
                >
                  <i className="fas fa-bars fa-lg " aria-hidden="true"></i> {/* Hide decorative icon */}
                </button>
              </div>

              {/* <div className='gameName'>Matka Jantri </div> */}
              <div id="gameNameid" className="gameName">
                <picture>
                  <source srcSet="https://app.matkajantri.com/JantriImage/JantriLogo.png" type="image/webp" />
                  {/* <img src={jantriPng} alt="Matka Jantri" className="gameName-logo" /> */}
                  <img
                    src={"https://app.matkajantri.com/JantriImage/JantriLogo.png"}
                    alt="Matka Jantri"
                    className="gameName-logo"
                    loading="eager"
                    fetchpriority="high"
                    width="150"  // ✅ Add the actual intrinsic width
                    height="43"  // ✅ Matches the CSS height
                  />
                </picture>
              </div>

              {/* Wallet Section */}
              {/* Apply flex alignment and consistent color to the container */}
              {/* <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                <i className="fa-solid fa-wallet" aria-hidden="true" style={{ marginRight: '5px' }}></i> 
                <span>
                  {!isNaN(wallet)
                    ? (Math.trunc(Number(wallet) * 100) / 100).toFixed(2)
                    : wallet}
                </span>

              </div> */}
              <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                <i
                  className="fa-solid fa-wallet"
                  aria-hidden="true"
                  style={{ marginRight: '5px' }}
                ></i>
                <span className="wallet-value">
                  {!isNaN(wallet)
                    ? (Math.trunc(Number(wallet) * 100) / 100).toFixed(2)
                    : wallet}
                </span>
              </div>

            </div>
          </div>
          <div className="sidebar">
            <div className="profile">
              <picture>
                <source srcSet={profileImgWebp} type="image/webp" />
                <img id="profile_picture" src={profileImgPng} alt="profile_picture" />
              </picture>
              <h3>{userInfo?.name}</h3>
              <p>
                <i className="fa-solid fa-wallet" style={{ color: 'white' }}></i>
                {" " + wallet}
              </p>
            </div>
            <hr className='seprateSidebar'></hr>
            <ul>
              {/* <li>
                <a className='deposit' onClick={() => { setIsDepositOpen(!isDepositOpen) }} >
                  <span className="icon"><i className="fa-solid fa-wallet"></i></span>
                  <span className="item">Deposit</span>
                </a>
                <div className="dropdown-container" style={{ display: isDepositOpen ? "block" : "none" }}>
                  <Link to="/deposit/depositMoney" onClick={() => setSideBarOpen(false)} >Deposit Money</Link>
                  <Link to="/deposit/depositHistory" onClick={() => setSideBarOpen(false)}>Despoit History</Link>
                </div>
              </li> */}
              {/* <li>
                <a className='withdraw' onClick={() => setIsWithdrawOpen(!isWithdrawOpen)}>
                  <span className="icon"><i className="fa-solid fa-indian-rupee-sign"></i></span>
                  <span className="item">Withdraw</span>
                </a>
                <div className="dropdown-container" style={{ display: isWithdrawOpen ? "block" : "none" }}>
                  <Link to="/withdraw/withdrawMoney" onClick={() => setSideBarOpen(false)}>Withdraw Money</Link>
                  <Link to="/withdraw/withdrawHistory" onClick={() => setSideBarOpen(false)}>Withdraw History</Link>
                </div>
              </li> */}
              <li>
                <Link className='add_client' to="/AddClient" onClick={() => setSideBarOpen(false)}>
                  <span className="icon"><i className="fa-solid fa-user-plus animated-bounce"></i></span>
                  <span className="item">Add Client</span>
                </Link>
              </li>
              <li>
                <Link className='edit_client' to="/EditClient" onClick={() => setSideBarOpen(false)}>
                  <span className="icon"><i className="fa-solid fa-user-edit animated-bounce"></i></span>
                  <span className="item">Edit Client</span>
                </Link>
              </li>
              <li>
                <Link className='add_game' to="/AddGame" onClick={() => setSideBarOpen(false)}>
                  <span className="icon"><i className="fa-solid fa-gamepad animated-bounce"></i></span>
                  <span className="item">Add Game</span>
                </Link>
              </li>
              <li>
                <Link className='delete_game' to="/deleteGame" onClick={() => setSideBarOpen(false)}>
                  <span className="icon"><i className="fa-solid fa-trash-can animated-bounce"></i></span>
                  <span className="item">Delete Game</span>
                </Link>
              </li>
              <li>
                <Link className='delete_client' to="/deleteClient" onClick={() => setSideBarOpen(false)}>
                  <span className="icon"><i className="fa-solid fa-user-xmark animated-bounce"></i></span>
                  <span className="item">Delete Client</span>
                </Link>
              </li>
              <li>
                <Link className='recharge_plans' to="/RechargePlans" onClick={() => setSideBarOpen(false)}>
                  <span className="icon"><i className="fa-solid fa-bolt animated-bounce"></i></span>
                  <span className="item">Recharge Plans</span>
                </Link>
              </li>
              <li>
                <Link
                  className="recharge_status"
                  to="/deposit/depositHistory"
                  onClick={() => setSideBarOpen(false)}
                >
                  <span className="icon">
                    <i className="fa-solid fa-hourglass-half animated-bounce"></i>
                  </span>
                  <span className="item">Recharge Status</span>
                </Link>
              </li>
              {/* rajan */}
              <li>
                <Link className='hisab_kitab' to="/hisabKitab" onClick={() => setSideBarOpen(false)}>
                  <span className="icon"><i className="fa-solid fa-file-invoice-dollar animated-bounce"></i></span>
                  <span className="item">Hisab Kitab</span>
                </Link>
              </li>
              <li>
                <Link className='laser_book' to="/laserBook" onClick={() => setSideBarOpen(false)}>
                  <span className="icon"><i className="fa-solid fa-book animated-bounce"></i></span>
                  <span className="item">Laser Book</span>
                </Link>
              </li>
              <li>
                <Link className='user_bets' to="/userBetsAndRevert" onClick={() => setSideBarOpen(false)}>
                  <span className="icon"><i className="fa-solid fa-walletfa-solid fa-indian-rupee-sign animated-bounce"></i></span>
                  <span className="item">User Bets</span>
                </Link>
              </li>
              <li>
                <Link className='user_bets' to="/lainDain" onClick={() => setSideBarOpen(false)}>
                  <span className="icon">
                    <i className="fa-solid fa-pen animated-bounce"></i>
                  </span>
                  <span className="item">Lain Dain</span>
                </Link>
              </li>
              <li>
                <a
                  className="whatsapp_support"
                  href={whatsappUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setSideBarOpen(false)}
                >
                  <span className="icon">
                    <i className="fa-brands fa-whatsapp animated-bounce"></i>
                  </span>
                  <span className="item">WhatsApp Support</span>
                </a>
              </li>

              <li>
                <a
                  className="join_telegram"
                  href="https://t.me/your_channel_or_group" // 🔁 Replace with your Telegram link
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setSideBarOpen(false)}
                >
                  <span className="icon">
                    <i className="fa-brands fa-telegram animated-bounce"></i>
                  </span>
                  <span className="item">Join Telegram</span>
                </a>
              </li>

              {/* <li>
                <Link to="/betHistory" onClick={() => setSideBarOpen(false)}>
                  <span className="icon"><i className="fa-brands fa-searchengin"></i></span>
                  <span className="item">History</span>
                </Link>
              </li> */}
              <li>
                <Link to="/helpSupport" onClick={() => setSideBarOpen(false)}>
                  <span className="icon"><i className="fa-solid fa-handshake-angle animated-bounce"></i></span>
                  <span className="item">Help and Support</span>
                </Link>
              </li>
              <li>
                <Link to="/videoTutorial" onClick={() => setSideBarOpen(false)}>
                  <span className="icon"><i className="fa-solid fa-handshake-angle animated-bounce"></i></span>
                  <span className="item">Video Tutorial</span>
                </Link>
              </li>
              <li>
                <Link className='add_game' to="/apk-nfo" onClick={() => setSideBarOpen(false)}>
                  <span className="icon">
                    <i className="fa-solid fa-file-archive animated-bounce"></i> {/* or fa-mobile-screen */}
                  </span>
                  <span className="item">APK Info</span>
                </Link>
              </li>
              <li className='LogoutButton'>
                <button onClick={handleLogout} className="nav-button">
                  <span id="logouticon" className="icon"><i className="fa-solid fa-right-from-bracket"></i></span>
                  <span className="item">Logout</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </>
  )
}
